import React from 'react';
import ReturnHome from './ReturnHome';

const ReturnHomeContainer = () => {
  return <ReturnHome />;
};

export default React.memo(ReturnHomeContainer);
